import { useDispatch } from 'react-redux'
import { Resume } from '@rio/types'

import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { actions, TemplateChangeHandler } from 'builder/modules/resumeEditor'
import { useTemplateCustomization } from 'builder/components/DocumentCustomizationModal/components/ResumeSidebar/hooks/useTemplateCustomization'

import { Colors } from './Colors/Colors'
import { Templates } from './Templates/Templates'
import * as Styled from './styles'

type Props = {
  resume: Resume
}

export const TemplatesContent = ({ resume }: Props) => {
  const dispatch = useDispatch()
  const { isPhone, isTablet } = useMediaQueries()
  const { templates, currentTemplate, resumeSpecificTemplateSettings } =
    useTemplateCustomization(resume)

  const handleTemplateUpdate: TemplateChangeHandler = id => {
    dispatch(actions.updateTemplate({ id }))
  }

  return (
    <Styled.Container>
      {!isPhone && !isTablet && (
        <Styled.ColorsContainer>
          <Colors
            resume={resume}
            currentTemplate={currentTemplate}
            resumeSpecificTemplateSettings={resumeSpecificTemplateSettings}
          />
        </Styled.ColorsContainer>
      )}

      <Styled.TemplatesContainer>
        <Templates
          templates={templates}
          currentTemplate={currentTemplate}
          currentDocument={resume}
          updateTemplate={handleTemplateUpdate}
        />
      </Styled.TemplatesContainer>

      {(isPhone || isTablet) && (
        <Styled.ColorsContainer>
          <Colors
            resume={resume}
            currentTemplate={currentTemplate}
            resumeSpecificTemplateSettings={resumeSpecificTemplateSettings}
          />
        </Styled.ColorsContainer>
      )}
    </Styled.Container>
  )
}
